import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=b9a9e428"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports